export const littleGenericEncart = {
  init() {
    $(document).on('click', '.js-lge:not(.js-fancyboxVideo):not([href])', e => {
      /* Open simpleTextPopin when clicking a LGE that is not a fancyboxVideo or a regular anchor */
      simpleTextPopin.open($(e.currentTarget).find('.simpleTextPopin'));
    });
  }
};